import {FilterKey, ValueFilter} from '../../../util/filterTypes';

type artifactFilterFieldName = 'alias' | 'tag';

export const getValueFromArtifactFilterString = (
  filterString: string | undefined,
  name: artifactFilterFieldName
): string => {
  if (!filterString) {
    return '';
  }
  let filterParsed: any;
  let value = '';
  try {
    filterParsed = JSON.parse(filterString);
    if (Object.prototype.hasOwnProperty.call(filterParsed, 'filter')) {
      filterParsed = JSON.parse(filterParsed.filter);
    }
  } catch (e) {
    // There isn't a better way to convert JSON string back to Filter
    console.warn(
      `error parsing trigger filter json.\nfilter: ${filterString}\nerror: ${e}`
    );
  }
  try {
    value = filterParsed.$or[0].$and[0][name].$regex;
  } catch (e) {
    console.warn(`error getting ${name} from filter: ${e}`);
  }
  return value;
};

export const createArtifactFilter = (
  name: artifactFilterFieldName,
  value: string
): ValueFilter<FilterKey> => {
  return {
    key: {section: 'artifact', name: name},
    op: 'REGEX',
    value: value,
  };
};
